module.exports = __webpack_public_path__ + "static/media/Exit.f16e79b2.svg";